export const DIVERSITY_TRAIT_MODEL = "diversity-trait";

const diversityTraitModel = {
  sexualOrientation: "",
  maritalStatus: "",
  minimumSalaryPreference: 0,
  careResponsibilities: false,
  religion: "",
  disabled: false
};

export default diversityTraitModel;
